import { render, staticRenderFns } from "./ShareOrderEditShareDialog.vue?vue&type=template&id=553da1ea&scoped=true"
import script from "./ShareOrderEditShareDialog.vue?vue&type=script&lang=js"
export * from "./ShareOrderEditShareDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "553da1ea",
  null
  
)

export default component.exports